
    import { Component, Vue } from 'vue-property-decorator';
    import { ITagType } from '@/interfaces/Tags/ITagType';
   // import { ITag } from '@/interfaces/Tags/ITag';
    import tagsAPI from '@/store/tagsAPI';
    @Component
    export default class AddTag extends Vue {
        private drpTagType = [] as Array<ITagType>;
        heading: string = "Add Tag";
        editdisable:boolean = false;
               
        private formValues = {
            TagTypeIdSelected: 0,
            tagname: ""           
        } as { [id: string]:any }

       
        private async register() {
            if (this.formValues.TagTypeIdSelected==0) { alert("Please Select the Tag Type")}
            else if (this.formValues.tagname=="") { alert("Please enter the Tag Name") }
            if (this.formValues.TagTypeIdSelected !=0 && this.formValues.tagname !="") {
                let formData: FormData = new FormData();
                formData.append('tagTypeId', this.formValues.TagTypeIdSelected);
                formData.append('tagName', this.formValues.tagname);

                if (this.$route.params.tagtypeid != undefined && this.$route.params.tagid != undefined) {
                    console.log("edit")
                    formData.append('tagId', this.$route.params.tagid);
                    var responseadd = await tagsAPI.updatetag(formData)
                    if (responseadd == "Success") {
                        alert("Editted Successfully");
                        this.$router.push({ path: "/Tags/" + this.formValues.TagTypeIdSelected });
                    }
                        
                    else
                        alert(responseadd);
                }
                else {
                    var responseedit = await tagsAPI.posttag(formData)
                    if (responseedit == "Success") {
                        alert("Added Successfully");
                        this.$router.push({ path: "/Tags/" + this.formValues.TagTypeIdSelected });
                    }                       
                    else
                        alert(responseedit);
                }
                
            }
            
        }
        private cancel() {
           this.formValues.TagTypeIdSelected=0;
           this.formValues.tagname="";
        }
        private async on_edit() {
           
            if (this.$route.params.tagtypeid != undefined && this.$route.params.tagid != undefined) {
                this.formValues.TagTypeIdSelected = this.$route.params.tagtypeid;
                this.heading = "Edit Tag";
                this.editdisable = true;
                if (this.formValues.TagTypeIdSelected != "") {
                   // await API.getTagByid(this.selected, Number(this.$route.params.id)).then((result) => { console.log(result) });
                 //   await tagsAPI.getTags(this.formValues.TagTypeIdSelected).then((result) => { this.editv = result.filter(m => m.id == Number(this.$route.params.id)) });
                   // console.log(this.editv[0].name);
                   // this.formValues.addtag = this.editv[0].name;
                }
            }
        }
        private async mounted() {
            try {
                this.drpTagType = await tagsAPI.getTagType();
                this.on_edit();
            } catch (error) {
               // this.loadingFailed = true;
               // this.errorMessage = '';
            } finally {
               // this.loading = false;
            }
        }
    }
